import { PageableResult } from "./Api";
import { CommonsStore } from "../model/CommonsStore";
import { Schema } from "./Schema";

export interface FindAllParams {
  filters: Filter[];
  sort?: Sort;
  page?: Page;
}

export interface LocalFindAllParams extends FindAllParams {
  sort: Sort;
  page: Page;
}

export const emptyParams = (): LocalFindAllParams => {
  return {
    filters: [],
    page: { pageNumber: 0, pageSize: 25 },
    sort: { order: "desc", sort: "id" }
  };
};

export interface Filter {
  field: string;
  value: string;
}

export interface Sort {
  order: "asc" | "desc";
  sort: string;
}

export interface Page {
  pageNumber: number;
  pageSize: number;
}

export interface DataSource<T, ID> {
  name: string;
  schema: Schema;
  listDataSource: ListDataSource<T, ID>;
  oneDataSource: OneDataSource<T, ID>;
  commons: CommonsStore;
}

export interface ListDataSource<T, ID> {
  name: string;
  schema: Schema;
  list: T[];
  total: number;
  params: LocalFindAllParams;
  selected: ID[];
  commons: CommonsStore;

  findAll(params?: FindAllParams, force?: boolean): Promise<PageableResult<T>>;
  exportAll(type: string, params?: FindAllParams): Promise<void>;
  delete(ids: ID[] | ID): Promise<void>;
  reload(reason: string): Promise<PageableResult<T>>;
  exportSelected(type: string, ids: ID[] | ID): Promise<void>;
  updateRows(ids: ID[] | ID, data: {}): Promise<void>;
  clear(): void;
  clearFilters(): void;
  setSelected(id: ID): void;
  clearSelected(): void;
  toggleSelect(id: ID): void;
  toggleSelectOne(id: ID): void;
  toggleSelectAll(): void;
}

export interface OneDataSource<T, ID> {
  name: string;
  url?: string;
  schema: Schema;
  one?: T;
  commons: CommonsStore;

  findOne(id: ID): Promise<T>;
  partialUpdate(dataPart: {}): Promise<void>;
  download(type: string): Promise<void>;
  upload(): Promise<void>;
  save(): Promise<T>;
  update(): Promise<T>;
  delete(): Promise<void>;
  change(one: T): T;
  rollback(): T | undefined;
  clearPkFields(): T | undefined;
  clear(): void;
}
